import React from "react";
import MainPicture from "components/comp/MainPicture";
import MajorBusiness from "components/comp/MajorBusiness";
import CompanyIntro from "components/comp/CompanyIntro";
import GoDetail from "components/comp/GoDetail";
import MiddleImg from "components/comp/MiddleImg";
import ArchiImg from "assets/images/architecture.jpg"
import LapImg from "assets/images/lap.jpg";
import prodImg from "assets/images/prod.png";
import OperationWay from "components/comp/OperationWay";
import OperationStrategy from "components/comp/OperationStrategy";
import ScheduleDogyo from "components/comp/ScheduleDogyo";
import GoDetail2 from "components/comp/GoDetail2";
import GoDetailUrl from "components/comp/GoDetailUrl";
import GoRodCutting from "components/comp/GoRodCutting";
import RodCutting from "components/comp/RodCutting";
import HyGateOneIntro from "components/comp/HyGateOneIntro";

const MainPage = () => {

  return (
    <main className="page-main"> 
      <MainPicture img={ArchiImg} alt=""/>
        <section className="company-main">
          <CompanyIntro/>
          <MajorBusiness/>
          <GoDetail to={"about"} page={"회사소개"}/>

          <MiddleImg img={LapImg} width="100%" height="600px"/>

          <OperationWay/>
          <OperationStrategy/>
          <GoDetail to={"competency"} page={"핵심역량"}/>

          <MiddleImg img={prodImg} width="100%" height="600px"/>

          <HyGateOneIntro/>
          <GoDetail to={"/product/hygateone"} page={"HyGateOne 제품소개"}/>

          <ScheduleDogyo/>
          <GoDetailUrl/>
          <RodCutting/>
          <section className="prodDt">
            <GoDetail2 to={"product"} page={"제품소개"}/>
            <GoRodCutting/>
          </section>
        </section>
    </main>
  );
};

export default MainPage;
